<template>
  <div class="note-app">
    <h1 class="app-title">Markdown笔记</h1>
    <div class="editor">
      <input class="note-title" v-model="editItem.title" placeholder="笔记标题">
      <textarea class="note-content" v-model="editItem.content" placeholder="输入Markdown内容" rows="10"></textarea>
      <div class="actions">
        <input type="file" @change="handleFileUpload" multiple>
        <button @click="saveNote">保存笔记</button>
        <button @click="syncToWebDAV">同步到WebDAV</button>
        <button @click="exportFilesToLocalFolder">导出到本地</button>
      </div>
    </div>
    预览
    {{editItem.content}}
    <markdown class="markdown-preview" :content="editItem.content"></markdown>
    <div class="note-list">
      <div class="note-item" v-for="note in this.$store.state.contentArr" :key="note.id" :style="{backgroundColor: note.background, color: note.color}">
        <div class="note-header">
          <span class="note-id">{{note.id}}</span>
          <span class="note-time">{{timeFormat(note.updateAt)}}</span>
          <button class="delete-btn" @click="deleteNote(note)">删除</button>
          <button class="edit-btn" @click="editNote(note.id)">修改</button>
        </div>
        <markdown :content="note.content"></markdown>
        <textarea class="note-edit" v-model="note.content" @input="adjustHeight($event)"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import localForage from 'localforage';
import { marked } from 'marked';
import { debounce, timeFormat } from "@/utils/utils"
import { nanoid } from "nanoid"
import Markdown from "@/components/Markdown"

export default {
  components: { Markdown },
  data() {
    return {
      markdownContent: '',
      processedMarkdown: '', // 用于存储处理后的Markdown
      editItem: {
        title: "未命名",
        content: "\n\n\n\n\n\n\n\n",
        postStatus: 'private',
        syncTime: 0,
        background: '#ffffff', // 背景颜色
        color: '#333333', // 字体颜色
        top: '',
        password: "",
        tags: {}, // { '网址': { background: '#56b9ba', color: '#fff', smart: false } }, // 智能标签，智能标签每次更新文本的时候会自动删除，然后根据文本内容来自动生成标签
        state: 0, // 0-正常 1-删除 2-归档
        secret: false, // 是否隐藏
        type: '', // 笔记类型
        height: 100,
      },
    };
  },
  computed: {
    // async renderMarkdown() {
    //   const renderedHtml = marked(this.markdownContent);
    //   // 你的替换逻辑，但不在这里直接实现
    //   this.processedMarkdown = renderedHtml; // 假设processedMarkdown是数据属性
    // }

  },
  mounted() {
    this.processMarkdownAndImages();
    this.loadNotes()
  },
  watch: {
    markdownContent(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.processMarkdownAndImages();
      }
    }
  },
  methods: {
    timeFormat,
    /**
     * 删除笔记，同时删除保存在本地的图片内容
     * @param note
     */
    deleteNote(note) {
      const webDav = this.$store.state.setting.webDav
      // 这里调用Vuex action或mutation来删除笔记
      // this.$store.dispatch('deleteNote', noteId);
      // 提取并删除所有文件图片
      const imageMatches = note.content.match(/\[.*?\]\((.*?)\)/g) || [];
      const uploadPromises = imageMatches.map(async (imgMarkdown) => {
        const imageName = imgMarkdown.match(/\((.*?)\)/)[1];
        console.log(imageName)
        if(imageName.startsWith(webDav.filePrefix)) {
          localForage.removeItem(imageName).then(() => {
            console.log(imageName + "已经删除")
          })
        }
      });

      this.$store.state.contentArr = this.$store.state.contentArr.filter((item) => item.id !== note.id)
      console.log(this.$store.state.contentArr.length)
      this.saveNotes()
    },
    editNote(noteId) {
      // 标记笔记为编辑状态，实现可以根据应用的具体逻辑调整
      // 例如，可以打开一个带有笔记内容的模态框来编辑笔记
      // console.log('Editing note', noteId);
      // 例如，this.$store.dispatch('editNote', noteId);
    },
    adjustHeight(event) {
      const element = event.target;
      element.style.height = 'auto'; // 先重置高度以便减小时能正确缩小
      element.style.height = element.scrollHeight + 'px'; // 根据内容自动调整高度
    },
    saveNote() {
      if (this.editItem.id) {
        const diffNote = this.getNoteDiff(this.editItemCopy, this.editItem)
        if (JSON.stringify(diffNote) !== '{}') {
          // 笔记格式转换
          this.editItem.updateAt = Math.floor(new Date().getTime() / 1000)
          this.editItem.syncTime = 0
        }
      } else { // 创建笔记
        if(this.editItem.content === '\n\n\n\n\n\n\n\n') return
        const id = nanoid() // => "V1StGXR8_Z5jdHi6B-myT"
        const createAt = Math.floor(new Date().getTime() / 1000)
        // 笔记格式转换
        this.editItem = {
          ...this.editItem,
          id,
          createAt: createAt,
          updateAt: createAt
        }
        if(this.editItem.content) { // 内容不空
          this.$store.state.contentArr.unshift(this.editItem)
          this.saveNotes()
          this.editItem = {
            title: "未命名",
            content: "\n\n\n\n\n\n\n\n",
            postStatus: 'private',
            syncTime: 0,
            background: '#ffffff', // 背景颜色
            color: '#333333', // 字体颜色
            top: '',
            password: "",
            tags: {}, // { '网址': { background: '#56b9ba', color: '#fff', smart: false } }, // 智能标签，智能标签每次更新文本的时候会自动删除，然后根据文本内容来自动生成标签
            state: 0, // 0-正常 1-删除 2-归档
            secret: false, // 是否隐藏
            type: '', // 笔记类型
            height: 100,
          }
        }
      }
    },
    /**
     * 保存所有笔记
     */
    saveNotes() {
      debounce(() => {
        localForage.setItem('ideaNotes', JSON.stringify(this.$store.state.contentArr))
      }, 0)

    },
    async markdown(content) {
      return await this.htmlRenderImages(marked(content))
    },
    /**
     * 载入所有笔记
     */
    async loadNotes() {
      const contentArr = await localForage.getItem('ideaNotes') || '[]'
      this.$store.state.contentArr = JSON.parse(contentArr)

      this.$store.state.contentArr = this.$store.state.contentArr.sort((a, b) => b.updateAt - a.updateAt)

      console.log(this.$store.state.contentArr)
    },

    async processMarkdownAndImages() {
      const renderedHtml = marked(this.markdownContent);

      // 创建一个虚拟的DOM容器，用于解析和操作HTML字符串
      const parser = new DOMParser();
      const doc = parser.parseFromString(renderedHtml, 'text/html');

      // 查询所有的<img>标签
      const images = doc.querySelectorAll('img');
      for (const img of images) {
        // 假设每个<img>的src属性原先都设置为在localForage中的键名
        const key = img.getAttribute('src');
        console.log("happen->key", key)
        const imageData = await localForage.getItem(key);
        console.log(key, imageData)
        if (imageData) {
          // 替换src属性为base64数据
          img.setAttribute('src', imageData);
        }
      }

      // 将更新后的HTML转换回字符串
      const serializer = new XMLSerializer();
      const updatedHtml = serializer.serializeToString(doc);

      // 更新Vue组件中的数据属性，以便重新渲染
      this.processedMarkdown = updatedHtml;
    },

    cleanFileName(fileName) {
      return fileName.replace(/[^a-zA-Z0-9.]/g, '_'); // 将所有非字母数字字符替换为下划线
    },
    handleFileUpload(event) {
      const webDav = this.$store.state.setting.webDav
      const files = event.target.files;
      Array.from(files).forEach(file => {
        const timestamp = new Date().getTime(); // 获取当前时间戳
        const cleanedFileName = this.cleanFileName(file.name); // 清理文件名
        const fileKey = `${webDav.filePrefix}_${timestamp}-${cleanedFileName}`; // 创建包含时间戳的文件键名

        const reader = new FileReader();
        reader.onload = async (e) => {
          await localForage.setItem(fileKey, e.target.result); // 使用时间戳键名保存图片
          // 根据文件类型决定是展示图片还是链接
          if (file.type.startsWith('image/')) {
            // 图片文件：在Markdown中以图片形式引用
            this.editItem.content += `![${file.name}](${fileKey})\n`;
          } else {
            // 非图片文件：在Markdown中以链接形式引用
            this.editItem.content += `[${file.name}](${fileKey})\n`;
          }
        };
        reader.readAsDataURL(file);
      });
    },
    async syncToWebDAV() {
      const webDav = this.$store.state.setting.webDav
      const webDavSetting = this.$store.state.setting.webDav.setting[webDav.type]
      const basicAuth = 'Basic ' + btoa(`${webDavSetting.username}:${webDavSetting.password}`);

      try {
        await this.createFolderIfNotExist(webDav.file_dir)
        // 同步Markdown内容
        await this.uploadToWebDAV(`xxxx.txt`, 'text/plain', this.markdownContent);

        // 提取并同步所有图片
        const imageMatches = this.markdownContent.match(/\[.*?\]\((.*?)\)/g) || [];
        const uploadPromises = imageMatches.map(async (imgMarkdown) => {
          const imageName = imgMarkdown.match(/\((.*?)\)/)[1];
          const imageData = await localForage.getItem(imageName);
          if (imageData) {
            const contentType = this.getContentType(imageData);
            await this.uploadImageToWebDAV(`${webDavSetting.url}/${webDavSetting.webDavPrefix}/${webDav.fileDir}/${imageName}`, contentType, imageData);
          }
        });

        // 并发上传所有图片
        await Promise.all(uploadPromises);
        alert('笔记和图片同步完成！');
      } catch (error) {
        console.error('同步到WebDAV时出错：', error);
        alert('同步失败，请检查控制台了解详情。');
      }
    },

    async createFolderIfNotExist(folderName) {
      const webDav = this.$store.state.setting.webDav
      const webDavSetting = this.$store.state.setting.webDav.setting[webDav.type]
      const basicAuth = 'Basic ' + btoa(`${webDavSetting.username}:${webDavSetting.password}`);

      return fetch(`${webDavSetting.url}/${webDavSetting.webDavPrefix}/${folderName}`, {
        method: 'MKCOL',
        headers: {
          'Authorization': basicAuth,
        }
      });
    },

    uploadToWebDAV(fileName, contentType, data) {
      const webDav = this.$store.state.setting.webDav
      const webDavSetting = this.$store.state.setting.webDav.setting[webDav.type]
      const basicAuth = 'Basic ' + btoa(`${webDavSetting.username}:${webDavSetting.password}`);

      return fetch(`${webDavSetting.url}/${webDavSetting.webDavPrefix}/${webDav.fileDir}/${fileName}`, {
        method: 'PUT',
        headers: {
          'Content-Type': contentType,
          'Authorization': basicAuth,
        },
        body: data,
      });
    },
    async exportFilesToLocalFolder() {
      // 检查浏览器是否支持文件系统访问API
      if (!window.showDirectoryPicker) {
        alert("你的浏览器不支持文件系统");
        return;
      }

      try {
        // 请求用户选择一个文件夹
        const directoryHandle = await window.showDirectoryPicker();

        // 获取存储在IndexedDB (localForage) 中的所有文件的键名
        const keys = await localForage.keys();

        for (const key of keys) {
          // 根据键名获取文件数据
          const fileData = await localForage.getItem(key);

          // 从Data URL中提取Base64编码的数据和MIME类型
          const [header, base64] = fileData.split(',');
          const mimeType = header.match(/:(.*?);/)[1];

          // 使用base64ToBlob函数将Base64数据转换为Blob
          const blob = this.base64ToBlob(base64, mimeType);

          // 创建或打开文件句柄
          const fileHandle = await directoryHandle.getFileHandle(key, { create: true });

          // 创建一个可写流
          const writable = await fileHandle.createWritable();

          // 将Blob写入文件
          await writable.write(blob);

          // 关闭流
          await writable.close();
        }

        alert("文件写入本地成功");
      } catch (error) {
        console.error("发生了错误:", error);
        alert("写入过程中发生了错误");
      }
    },
    async uploadImageToWebDAV(url, contentType, dataURL) {
      const webDav = this.$store.state.setting.webDav
      const webDavSetting = this.$store.state.setting.webDav.setting[webDav.type]
      const basicAuth = 'Basic ' + btoa(`${webDavSetting.username}:${webDavSetting.password}`);

      const base64ContentArray = dataURL.split(",");
      const mimeType = base64ContentArray[0].match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      const base64Data = base64ContentArray[1];

      // 将Base64字符串转换为Blob
      const blobData = this.base64ToBlob(base64Data, mimeType);

      return fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': contentType,
          'Authorization': basicAuth,
        },
        body: blobData, // 使用Blob数据作为请求体
      });
    },

    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: mimeType });
    },

    getContentType(dataURL) {
      // 提取MIME类型
      const mimeType = dataURL.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
      if (mimeType && mimeType.length > 1) {
        return mimeType[1];
      } else {
        return 'application/octet-stream'; // 默认类型
      }
    }

  },
};
</script>

<style scoped>
.note-app {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.app-title {
  margin-bottom: 20px;
  text-align: center;
}

.editor, .note-list {
  margin-bottom: 20px;
}

.note-title, .note-content, .note-edit {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.note-content, .note-edit {
  resize: vertical;
}

.actions {
  text-align: right;
}

.actions button {
  margin-left: 10px;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
}

.actions input[type="file"] {
  display: inline-block;
}

.markdown-preview {
  border: 1px solid #eee;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #f9f9f9;
}

.note-item {
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.note-id {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}

.note-item img, .markdown-preview img {
  max-width: 100%;
  height: auto;
  display: block; /* 确保图片不会在其旁边有文本或其他元素 */
  margin: 0 auto; /* 如果需要，可以让图片在其容器内居中显示 */
}

button {
  margin-left: 10px;
  padding: 5px 10px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;
}

.note-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.note-header .note-id, .note-header .note-time {
  flex: 1;
}

.delete-btn {
  background-color: #ff4d4f;
}

.delete-btn:hover {
  background-color: #ff7875;
}

.edit-btn {
  background-color: #1890ff;
}

.edit-btn:hover {
  background-color: #40a9ff;
}

@media screen and (max-width: 768px) {
  .note-app {
    padding: 10px;
  }

  .actions button, .note-title, .note-content, .note-edit {
    margin-top: 10px;
  }
}

</style>
